/**
 * @type {import('gatsby').GatsbyConfig}
 */
const buildEnvs = require('./_envs.json');
const {activeEnv, pluginAdvancedSitemap} = require('./gatsby-apis/configs');

const GATSBY_SITE_URL =
    process.env.GATSBY_SITE_URL ||
    (buildEnvs[activeEnv]
        ? buildEnvs[activeEnv].GATSBY_SITE_URL
        : 'http://localhost:8000');
const GATSBY_DOMAIN =
    process.env.GATSBY_DOMAIN ||
    (buildEnvs[activeEnv]
        ? buildEnvs[activeEnv].GATSBY_DOMAIN
        : 'localhost');
const adHocCmsEnv = process.env.GATSBY_ADHOC_CMS || 
    (( activeEnv === 'qa' || activeEnv === 'production' ) ? activeEnv : 'development');

const WPGRAPHQL_URL =
    process.env.WPGRAPHQL_URL ||
    (buildEnvs[activeEnv]
        ? buildEnvs[activeEnv].WPGRAPHQL_URL
        : 'http://127.0.0.1:8888/graphql');   

module.exports = {
    
    siteMetadata: {
        title: process.env.GATSBY_SITE_TITLE || "Quicken Loans",
        siteUrl: GATSBY_SITE_URL,
        domain: GATSBY_DOMAIN
    },
    // ref: https://www.gatsbyjs.com/docs/reference/release-notes/v4.7/#trailingslash-option
    trailingSlash: "ignore",
    plugins: [
        {
            resolve: 'gatsby-source-wordpress',
            options: {
                url: WPGRAPHQL_URL || 'https://cms.quickenloans.com/graphql',
                production: {
                    allow404Images: true,
                    allow401Images: true,
                },
                development: {
                    allow404Images: true,
                    allow401Images: true,
                },
                schema: {
                    timeout: 180000,
                    perPage:20,
                    requestConcurrency: 12,
                    previewRequestConcurrency: 8,
                }
            }
        }, 
        "gatsby-plugin-image", 
        "gatsby-plugin-sharp", 
        "gatsby-transformer-sharp", 
        {
            resolve: "gatsby-plugin-sass",
            options: {
                sassOptions: {
                    api: "modern",
                    silenceDeprecations: ['legacy-js-api', 'import', 'mixed-decls'],
                }
            }
        },
        /**
         * Disable processing of images in markdown
         */
        {
            resolve: "gatsby-transformer-remark",
            // options:
            // {
            //     plugins:
            //     [
            //         {
            //             resolve: "gatsby-remark-images",
            //             options:
            //             {
            //                 maxWidth: 800,
            //             }
            //         },
            //         {
            //             resolve: "gatsby-remark-images-remote",
            //             options:
            //             {
            //                 maxWidth: 800,
            //                 linkImagesToOriginal: false,
                            
            //             }
            //         }
            //     ]
            // }
        },
        {
            resolve: 'gatsby-plugin-minify-classnames',
            options: {
                dictionary:
                    'bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ0123456789',
                // enableOnDevelopment: true,
            },
        },
        {
            resolve: 'gatsby-plugin-manifest',
            options: {
                "icon": "src/content/assets/quicken-loans-icon.svg"
            }
        },
        {
            resolve: 'gatsby-plugin-advanced-sitemap',
            options: pluginAdvancedSitemap.config(GATSBY_SITE_URL),
        },
        'gatsby-transformer-json',
        /**
         * We need the following plugin so that it adds the "File.publicURL" to our site
         * It will allow us to access static url's for assets like PDF's
         *
         * See https://www.gatsbyjs.org/packages/gatsby-source-filesystem/ for more info
         */
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                "name": 'assets',
                path: `${__dirname}/src/content/assets`,
            },
            __key: "images"
        },
        {
            resolve: `gatsby-source-filesystem`,
            options: {
                name: `adhoc-cms`,
                path: `${__dirname}/src/content/adhoc-cms/${adHocCmsEnv}`,
            },
        },
        {
            resolve: 'gatsby-plugin-google-tagmanager',
            options: {
                id: buildEnvs[ activeEnv ]?.GA_ID,
                includeInDevelopment: (activeEnv === 'qa'),
            },
        },
    ]
};

